import {useAuthStore, useLoginClickHandler} from "../../app-layout/authStore";
import {Button} from "@mui/material";
import React from "react";

export function SignInButton() {
    const authState = useAuthStore();
    const loginHandler = useLoginClickHandler(authState);

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={loginHandler}
        >
            Sign in
        </Button>
    );
}